import { Klass, u_ } from "@pressmedia/webappbase";

function _initialize(opt) {
	if( u_.isObject(opt) && u_.isFunction(opt.onReadyFirst) ) {
		this._onReadyFirst = opt.onReadyFirst;
		delete opt.onReadyFirst;
	}
	
	if( Klass("VuwWysiwygField").parent._initialize.call(this, opt) ) {
		const vuwForm = this.getForm();
		
		// [app]
		if( !( opt.app instanceof Klass("WebAppBase") ) ) {
			if( vuwForm && vuwForm.app instanceof Klass("WebAppBase") ) {
				this.app = vuwForm.app;
			} else {
				throw new TypeError("'app' must be an instance of WebAppBase.");
			}
		}
		
		// [config]
		u_.isObject(this.config) || (this.config = {});
		
		// theme
		if(this.config.theme) {
			this.theme = this.config.theme;
		}
		
		// toolbar
		if( Object.prototype.hasOwnProperty.call(this.config, "toolbar") ) {
			if( Array.isArray(this.config.toolbar) ) {
				this.config.toolbar.forEach(grp => {
					Array.isArray(grp) && grp.forEach(handle => {
						let props;
						switch(handle) {
							case "image": {
								props = this.getFileUploaderProps("img");
							} break;
							
							case "pdf":
							case "office": {
								props = this.getFileUploaderProps(handle);
							} break;
						}
						
						u_.isObject(props) && this.add(`${handle}Uploader`, props);
					});
				});
			} else {
				delete this.config.toolbar;
			}
		}
		
		// styleSheet
		if(this.config.styleSheet) {
			// スタイルシートが設定されている場合はiframeを利用
			this.useFrame = true;
		}
		
		// fileDir
		if( !this.config.fileDir || !u_.isString(this.config.fileDir) ) {
			this.config.fileDir = vuwForm.config.fileDir || "";
		}
		
		// uploadCallbacksが未設定の場合
		if( !u_.isObject(this.uploadCallbacks) ) {
			if( vuwForm && u_.isObject(vuwForm.fileUploaderCallbacks) ) {
				// フォームにfileUploaderCallbacksが設定されていれば反映する
				this.uploadCallbacks = vuwForm.fileUploaderCallbacks;
				
			} else {
				this.uploadCallbacks = {};
			}
		}
		
		// 文字数制限のバリデート関数をオーバーライド
		this._validations.ltd = val => {
			val = this.getTextVal().replace(/\n$/, "");
			const l = String(val).length;
			!!l && this.$self.attr("data-length", `現在${l}文字です`);
			return !u_.isNumber(this.ltd) || l <= this.ltd;
		};
		
		// import js plugin
		this._promise = this._importPlugin();
		
		if(!this.useFrame) {
			// import plugin's css (if not useFrame)
			this._promise = Promise.all([
				this._promise,
				this._importPluginStyleSheet()
			]);
		}
		
	} else {
		return false;
	}
}

export default _initialize;
